<section class="bg-accent-900 shadow-black-inset min-w-60 rounded-2xl rounded-br-none p-1">
  <nav class="bg-primary-700 flex w-full flex-col items-stretch justify-between gap-1 rounded-2xl rounded-br-none px-3 py-2 text-center">
    @for (item of extraItems; track $index) {
    <a
      class="text-primary-300 group flex items-center gap-4 p-2 text-left transition-colors duration-300 hover:text-white"
      [routerLink]="item.route"
      (click)="selected.emit()">
      <span
        class="my-auto grid w-7"
        [style.aspect-ratio]="item.iconRatio">
        <icon-app
          class="col-start-1 row-start-1 h-full w-full transition-opacity duration-300 group-hover:opacity-0"
          [style.opacity]="isActive(item.route) ? '0' : null"
          [name]="item.inactive_icon" />
        <icon-app
          class="col-start-1 row-start-1 h-full w-full opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          [style.opacity]="isActive(item.route) ? '1' : null"
          [name]="item.active_icon" />
      </span>
      <span
        class="preset-title-5 text-center whitespace-nowrap"
        [class.text-white]="isActive(item.route)">
        {{ item.label }}
      </span>
    </a>
    }
  </nav>
</section>
